module.exports = __webpack_public_path__ + "9c473e5e2992c03c6d37fa4b3155652a.svg";